import { ref, watch, computed, onMounted } from "@vue/composition-api";
import store from "@/store";

// Notification
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ability from "@/libs/acl/ability";

export default function useStaffsList() {
  // Use toast
  const toast = useToast();

  const refStaffListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    { key: "user_number", label: "編號", sortable: true, class: 'sticky-column' },
    //position maybe the role ignore it first
    { key: "position", label: "職位", sortable: true, class: 'sticky-column' },
    { key: "actions", label: "操作", class: 'sticky-column' },
    { key: "name_cn", label: "中文姓名" },
    { key: "name", label: "系統帳號名稱" },
    { key: "locked", label: "封鎖"},
    { key: "is_active", label: "狀態" },
    { key: "phone", label: "聯絡電話" },
    { key: "email", label: "電郵地址"},
    { key: "roles", label: "權限"},
    
/*     { key: "address", label: "地址", sortable: true },
    { key: "gender", label: "性別" },
    { key: "id_number", label: "身份證號碼", sortable: true },
    { key: "date_of_birth", label: "出生日期", sortable: true },
    { key: "bank.name", label: "銀行名稱", sortable: true },
    { key: "bank_account", label: "銀行號碼", sortable: true },
    { key: "join_date", label: "加入日期" }, */
  ];
  const perPage = ref(10);
  const totalRow = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("id");
  const isSortDirDesc = ref(true);

  const dataMeta = computed(() => {
    const localItemsCount = refStaffListTable.value
      ? refStaffListTable.value.localItems.length
      : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalRow.value,
    };
  });

  const refetchData = () => {
    //refStaffListTable.value.refresh();
    fetchStaffs();
  };

  const staffsList = ref(null);

  const filter_gender_id = ref(null);
  const filter_worker_status = ref(null);
  const filter_bank_id = ref(null);
  const filter_payment_method_id = ref(null);

  watch(
    [currentPage, perPage, searchQuery, filter_gender_id, filter_worker_status, filter_bank_id, filter_payment_method_id],
    () => {
      refetchData();
    }
  );
  const fetchStaffs = (ctx, callback) => {
    store
      .dispatch("staff/fetchStaffs", {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        gender_id: filter_gender_id.value,
        bank_id: filter_bank_id.value,
        payment_method_id: filter_payment_method_id.value,
        is_active: filter_worker_status.value,
      })
      .then((response) => {
        console.log('user', response)
        const { users, total } = response.data;
        //callback(users);
        totalRow.value = total;
        staffsList.value = users
      })
      .catch((err) => {
        console.log(err);
        toast({
          component: ToastificationContent,
          props: {
            title: "獲取貸款清單時出錯",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
  };

  const genderOptions = ref([]);
  const bankOptions = ref([]);
  const paymentMethodStatusOptions = ref([]);

  const refetchOption = () => {
    store
      .dispatch("app/fetchOptionList", {
        genders: true,
        worker_statuses: true,
        banks: true,
        payment_methods: true
      })
      .then((response) => {
        genderOptions.value = response.data.genders;
        bankOptions.value = response.data.banks;
        paymentMethodStatusOptions.value = response.data.payment_methods;
      });
  };

  onMounted(() => {
    refetchData();
    refetchOption();
  });

  return {
    fetchStaffs,
    tableColumns,
    perPage,
    currentPage,
    totalRow,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    staffsList,
    refStaffListTable,
    ability,
    refetchData,
    filter_gender_id,
    filter_bank_id,
    filter_payment_method_id,
    filter_worker_status,
    genderOptions,
    bankOptions,
    paymentMethodStatusOptions,
    
  };
}
